import { Col, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import MainHeader from '../components/MainHeader'

import { Link } from 'react-router-dom'
import { useHasAccess } from '../../components/HasAccess'
import { Permission } from '../../utils/permissions'
import { LayoutFooter } from '../components/LayoutFooter'

const { Content } = Layout

export const UsersLayout: React.FC = () => {
  const { hasAccess } = useHasAccess()

  const subItems = [
    {
      key: 'list',
      label: <Link to={'list'}>Clients</Link>,
      hasAccess: hasAccess(Permission.listUser),
    },
    {
      key: 'segments',
      label: <Link to={'segments'}>Segments</Link>,
      hasAccess: hasAccess([Permission.listUser]),
    },
    {
      key: 'transactions',
      label: <Link to={'transactions'}>Transactions</Link>,
      hasAccess: hasAccess(Permission.listReservation),
    },
  ]

  return (
    <Layout>
      <MainHeader subItems={subItems.filter((item) => item.hasAccess)} />
      <Layout style={{ minHeight: '100vh', marginTop: 128 }}>
        <Content>
          <Row className="container-row">
            <Col xs={24} className="px-4">
              <Outlet />
            </Col>
          </Row>
        </Content>
        <LayoutFooter />
      </Layout>
    </Layout>
  )
}
